import type { SxProps, Theme } from '@mui/material';

/** Blue = scheduled customer (no WO), Green = work order created. */
export const SCHEDULE_LINK_COLORS = {
  withWorkOrder: {
    bg: '#E8F5E9',
    color: '#2E7D32',
  },
  customerSchedule: {
    bg: '#E3F2FD',
    color: '#1565C0',
  },
} as const;

export function getScheduleLinkColors(workOrderId?: number | null): {
  bg: string;
  color: string;
} {
  return workOrderId
    ? SCHEDULE_LINK_COLORS.withWorkOrder
    : SCHEDULE_LINK_COLORS.customerSchedule;
}

export const SCHEDULE_LINK_LEGEND_COLORS = {
  withWorkOrder: {
    bgcolor: '#E8F5E9',
    color: '#2E7D32',
    borderColor: '#2E7D32',
    fontSize: '0.65rem',
  } as SxProps<Theme>,
  customerSchedule: {
    bgcolor: '#E3F2FD',
    color: '#1565C0',
    borderColor: '#1565C0',
    fontSize: '0.65rem',
  } as SxProps<Theme>,
};

/** @deprecated Prefer getScheduleLinkColors — kept for month pickup/delivery chips if needed */
export const DATE_TYPE_COLORS = {
  pickup: {
    bgcolor: '#FFF3E0',
    color: '#E65100',
    borderColor: '#E65100',
    fontSize: '0.55rem',
    height: 14,
    '& .MuiChip-label': { px: 0.5 },
  } as SxProps<Theme>,
  delivery: {
    bgcolor: '#E0F2F1',
    color: '#00695C',
    borderColor: '#00695C',
    fontSize: '0.55rem',
    height: 14,
    '& .MuiChip-label': { px: 0.5 },
  } as SxProps<Theme>,
  both: {
    bgcolor: '#F3E5F5',
    color: '#6A1B9A',
    borderColor: '#6A1B9A',
    fontSize: '0.55rem',
    height: 14,
    '& .MuiChip-label': { px: 0.5 },
  } as SxProps<Theme>,
};

export const DATE_TYPE_LEGEND_COLORS = SCHEDULE_LINK_LEGEND_COLORS;

export type WoDateBadgeType = 'pickup' | 'delivery' | 'both' | null;

export function getWoDateBadgeType(
  woPickupDate?: string | null,
  woDeliveryDate?: string | null,
): WoDateBadgeType {
  const hasPickup = Boolean(woPickupDate);
  const hasDelivery = Boolean(woDeliveryDate);
  if (hasPickup && hasDelivery) return 'both';
  if (hasPickup) return 'pickup';
  if (hasDelivery) return 'delivery';
  return null;
}

export function getWoDateBadgeLabel(type: WoDateBadgeType): string {
  switch (type) {
    case 'both':
      return 'P+D';
    case 'pickup':
      return 'Pickup';
    case 'delivery':
      return 'Delivery';
    default:
      return '';
  }
}
